export interface Account {
  id: string;
  username: string;
  password: string; // In production, this should be hashed
  role: "admin" | "user" | "purchase";
  branchId?: string; // Only for user role
  branchName?: string; // Only for user role
}

export const ACCOUNTS: Account[] = [
  {
    id: "acc-001",
    username: "admin",
    password: "Admin@2025tkz",
    role: "admin",
  },
  {
    id: "acc-001a",
    username: "vip",
    password: "vip@2025tkz",
    role: "admin",
  },
  // account check phan loai thuoc
  {
    id: "acc-001b",
    username: "mh-vip",
    password: "mh@2026mhz",
    role: "purchase",
  },
  // Kho tổng
  {
    id: "acc-002",
    username: "khotong",
    password: "KT@2025mSp",
    role: "user",
    branchId: "66847e41-5b66-4529-b955-e63c7e8b50b0",
    branchName: "Kho tổng",
  },
  // NHÀ THUỐC PHARCECO - MAI ĐỘNG
  {
    id: "acc-003",
    username: "maidong",
    password: "MD@2025xFq",
    role: "user",
    branchId: "527cff6e-db67-49b6-9e6d-150d27e760ce",
    branchName: "NHÀ THUỐC PHARCECO - MAI ĐỘNG",
  },
  // NHÀ THUỐC PHARCECO - XUÂN PHƯƠNG
  {
    id: "acc-004",
    username: "xuanphuong",
    password: "XP@2025bKw",
    role: "user",
    branchId: "59022194-b4ea-4bf2-838c-1b11a055a7f3",
    branchName: "NHÀ THUỐC PHARCECO - XUÂN PHƯƠNG",
  },
  // NHÀ THUỐC PHARCECO - NGUYỄN KHUYẾN
  {
    id: "acc-005",
    username: "nguyenkhuyen",
    password: "NK@2025rLd",
    role: "user",
    branchId: "1c773a52-8218-4749-b517-0b2823531067",
    branchName: "NHÀ THUỐC PHARCECO - NGUYỄN KHUYẾN",
  },
  // NHÀ THUỐC PHARCECO - YÊN XÁ
  {
    id: "acc-006",
    username: "yenxa",
    password: "YX@2025pNv",
    role: "user",
    branchId: "03b696f6-af73-4927-98dd-424204ca78a9",
    branchName: "NHÀ THUỐC PHARCECO - YÊN XÁ",
  },
  // NHÀ THUỐC PHARCECO - CHÍNH KINH
  {
    id: "acc-007",
    username: "chinhkinh",
    password: "CK@2025zHm",
    role: "user",
    branchId: "11734016-7153-4581-8d79-1eed546f87ce",
    branchName: "NHÀ THUỐC PHARCECO - CHÍNH KINH",
  },
  // NHÀ THUỐC PHARCECO - LẠC LONG QUÂN
  {
    id: "acc-008",
    username: "laclongquan",
    password: "LLQ@2025cTy",
    role: "user",
    branchId: "55a1ca71-8536-43b2-bb8d-3e0cae3ae6d1",
    branchName: "NHÀ THUỐC PHARCECO - LẠC LONG QUÂN",
  },
  // NHÀ THUỐC PHARCECO - AN DƯƠNG
  {
    id: "acc-009",
    username: "anduong",
    password: "AD@2025jGs",
    role: "user",
    branchId: "a3e8c20e-0594-45ab-bf26-a789ad6aae09",
    branchName: "NHÀ THUỐC PHARCECO - AN DƯƠNG",
  },
  // NHÀ THUỐC PHARCECO - LẠC TRUNG
  {
    id: "acc-010",
    username: "lactrung",
    password: "LT@2025eWp",
    role: "user",
    branchId: "c7b62a0e-4c35-46d5-a19f-b7efb3002eee",
    branchName: "NHÀ THUỐC PHARCECO - LẠC TRUNG",
  },
  // NHÀ THUỐC PHARCECO - NGUYỄN VIẾT XUÂN
  {
    id: "acc-011",
    username: "nguyenvietxuan",
    password: "NVX@2025aRq",
    role: "user",
    branchId: "0d41034b-1491-41e0-a5d5-9fc22ff870e3",
    branchName: "NHÀ THUỐC PHARCECO - NGUYỄN VIẾT XUÂN",
  },
  // NHÀ THUỐC PHARCECO - KẾ VẼ
  {
    id: "acc-012",
    username: "keve",
    password: "KV@2025dFn",
    role: "user",
    branchId: "5dd16191-bdcd-4185-a6f8-79eb6747126d",
    branchName: "NHÀ THUỐC PHARCECO - KẾ VẼ",
  },
  // NHÀ THUỐC PHARCECO - CỔ NHUẾ
  {
    id: "acc-013",
    username: "conhue",
    password: "CN@2025sOu",
    role: "user",
    branchId: "40ea358b-1def-4496-a309-af372871cfa2",
    branchName: "NHÀ THUỐC PHARCECO - CỔ NHUẾ",
  },
];

/**
 * Hàm xác thực tài khoản
 * @param username - Tên đăng nhập
 * @param password - Mật khẩu
 * @returns Account object nếu thành công, null nếu thất bại
 */
export const authenticateAccount = (
  username: string,
  password: string,
): Account | null => {
  const account = ACCOUNTS.find(
    (acc) => acc.username === username && acc.password === password,
  );
  return account || null;
};

/**
 * Hàm lấy thông tin tài khoản theo ID
 * @param id - ID tài khoản
 * @returns Account object hoặc null
 */
export const getAccountById = (id: string): Account | null => {
  return ACCOUNTS.find((acc) => acc.id === id) || null;
};

/**
 * Hàm kiểm tra quyền admin
 * @param account - Account object
 * @returns true nếu là admin, false nếu không
 */
export const isAdmin = (account: Account): boolean => {
  return account.role === "admin";
};

export const isMH = (account: Account): boolean => {
  return account.role === "purchase";
};

/**
 * Hàm lấy branch ID có quyền truy cập
 * @param account - Account object
 * @returns Array of branch IDs
 */
export const getAccessibleBranches = (account: Account): string[] => {
  if (isAdmin(account)) {
    // Admin có quyền truy cập tất cả chi nhánh
    return ACCOUNTS.filter((acc) => acc.branchId)
      .map((acc) => acc.branchId as string)
      .filter((v, i, a) => a.indexOf(v) === i); // Remove duplicates
  }
  // User chỉ có quyền truy cập chi nhánh của mình
  return account.branchId ? [account.branchId] : [];
};

/**
 * Hàm kiểm tra quyền truy cập chi nhánh
 * @param account - Account object
 * @param branchId - Branch ID cần kiểm tra
 * @returns true nếu có quyền truy cập, false nếu không
 */
export const hasAccessToBranch = (
  account: Account,
  branchId: string,
): boolean => {
  const accessibleBranches = getAccessibleBranches(account);
  return accessibleBranches.includes(branchId);
};

/**
 * Hàm lưu session tài khoản vào localStorage
 * @param account - Account object
 */
export const saveAccountSession = (account: Account): void => {
  localStorage.setItem(
    "currentAccount",
    JSON.stringify({
      id: account.id,
      username: account.username,
      role: account.role,
      branchId: account.branchId,
      branchName: account.branchName,
    }),
  );
};

/**
 * Hàm lấy session tài khoản từ localStorage
 * @returns Account object hoặc null
 */
export const getAccountSession = (): Account | null => {
  const session = localStorage.getItem("currentAccount");
  return session ? JSON.parse(session) : null;
};

/**
 * Hàm xóa session tài khoản
 */
export const clearAccountSession = (): void => {
  localStorage.removeItem("currentAccount");
};
